import { useElements, useStripe as useStripeClient } from '@stripe/react-stripe-js'

export const useStripe = () => {
  const client = useStripeClient()
  const elements = useElements()

  return { client, elements }
}
